define('responsive-gameday/views/distributors/viewDistributors/PitchByPitchDistributor',['require','exports','module','GameDayCore','jquery','./ViewDistributorBase','../../Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../events/DistributionEvents','extant/extant','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/baseball/GameStates'],function(require,exports,module) {
	var GDC = require("GameDayCore"),
		$ = require("jquery"),
		ViewDistributorClass = require("./ViewDistributorBase"),
		UpdateEvents = require("../../Monitor/Events/ViewModelUpdateEvents"),
		MessageService = require("message-service/message-service"),
		DistEvents = require("../events/DistributionEvents"),
		exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
		GameStates = require("GameDayCore/GDModel/enums/baseball/GameStates");

	var Superclass;

	function PitchByPitchDataPack(game){
		var that = this,
			gameData = game.gameData,
			play = $.extend({ }, game.getCurrentPlay());

		// Grab innings data depending on what half inning we're in
		if (exists(play, "pitchEvents")) { 
			play.pitchEvents = play.pitchEvents.slice(0).reverse(); 
		}
		this.currentPlay = play;
		this.currentHalf = game.liveData.plays.playsByInning[play.about.inning - 1][play.about.halfInning].slice(0).reverse();

		// Shift the current play off the inning half array to avoid duplication
		if(this.currentHalf[0].about.atBatIndex === play.about.atBatIndex){
			this.currentHalf.shift();
		}
		this.teams = gameData.teams;
		// this.scoreMessage = function(){
		// 	return that.getScoreMessage(this,gameData.teams);
		// }
	}

	PitchByPitchDataPack.prototype.mugshot = function(){
		return resourcePath.get('mugshot',{ pid : this.id});
	};

	PitchByPitchDataPack.prototype.outsText = function(){
		return (parseInt(this.count.outs,10) <= 1)  ? "out" :"outs";
	};

	// /*
	//  * When a play results in a scoring change, show the new
	//  * score on the innings data event
	//  */
	// PitchByPitchDataPack.prototype.getScoreMessage = function(play,teams){
	// 	return this.about.isScoringPlay && this.result.score ?
	// 			teams.away.name.abbrev + " " + this.result.score.away + " - " + teams.home.name.abbrev + " " + this.result.score.home : null;
	// };

	function PitchByPitchDistributor(evt) {
		this.eventType = evt;
        Superclass.constructor.call(this,evt);

		MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
		MessageService.addListener.call(this, UpdateEvents.REQUEST_PITCHBYPITCH_DATA, this.handleUpdateRequest);
	}

	ViewDistributorClass.spawn(PitchByPitchDistributor).define({
		prepDataForView: function() {
			this.dataPack = new PitchByPitchDataPack(this.game);
			this.dispatchUpdates();
		}
	});

	Superclass = PitchByPitchDistributor.superclass;

	return PitchByPitchDistributor;
});

